import { cleanSequence } from "@/lib/science/sequence";

export interface GcResult {
  length: number;
  a: number;
  c: number;
  g: number;
  t: number;
  other: number;
  gcCount: number;
  atCount: number;
  gcPercent: number;
  atPercent: number;
}

/** GC content and base composition of a DNA/RNA sequence. U is counted as T. */
export function gcContent(input: string): GcResult {
  const seq = cleanSequence(input);
  let a = 0;
  let c = 0;
  let g = 0;
  let t = 0;
  let other = 0;
  for (const ch of seq) {
    if (ch === "A") a++;
    else if (ch === "C") c++;
    else if (ch === "G") g++;
    else if (ch === "T" || ch === "U") t++;
    else other++;
  }
  const length = seq.length;
  const gcCount = g + c;
  const atCount = a + t;
  const denom = gcCount + atCount;
  return {
    length,
    a,
    c,
    g,
    t,
    other,
    gcCount,
    atCount,
    gcPercent: denom > 0 ? (gcCount / denom) * 100 : 0,
    atPercent: denom > 0 ? (atCount / denom) * 100 : 0,
  };
}
